import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface Props {
  slackChannelId: string;
}

export const useUpdateSlackChannel = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateSlackChannel = async (data: Props) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/org/${orgId}/slack-channel`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to update Slack channel');
    }
  };

  return useMutation({
    mutationFn: updateSlackChannel,
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, { orgId }]);
    },
  });
};
